import type { FormDefinition } from '@/core/templates/types'

export default {
  sections: {
    Teilnehmer: {
      fields: [
        { id: 'Teilnehmer.Name, Vorname', control: 'text-or-date' },
        { id: 'Teilnehmer.Anschrift', control: 'text-or-date' },
        { id: 'Teilnehmer.Geburtsdatum', control: 'text-or-date' },
      ],
    },
    Kostenträger: {
      fields: [
        { id: 'Kostenträger.Kostenträger', control: 'text-or-date' },
        { id: 'Kostenträger.Kundennummer', control: 'text-or-date' },
        { id: 'Kostenträger.Aktivierungsgutschein-Nr', control: 'text-or-date' },
      ],
    },
    Maßnahme: {
      fields: [
        { id: 'Maßnahme.Titel', control: 'text-or-date' },
        { id: 'Maßnahme.Nummer', control: 'text-or-date' },
        { id: 'Maßnahme.Abschluss', control: 'text-or-date' },
        { id: 'Maßnahme.Datum Beginn', control: 'text-or-date' },
        { id: 'Maßnahme.Datum Ende', control: 'text-or-date' },
        { id: 'Maßnahme.Coachingeinheiten', control: 'text-or-date' },
        { id: 'Maßnahme.Kosten', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
